module.exports = __webpack_public_path__ + "static/img/qr.29f72f59.png";